import React from 'react';
import './App.css';
import { AuthProvider, useAuth } from './AuthContext';
import AuthPage from './pages/AuthPage';
import TeacherDashboard from './pages/TeacherDashboard';
import StudentDashboard from './pages/StudentDashboard';

function AppContent() {
  const { currentUser, userProfile, loading } = useAuth();

  // ── Loading State ──────────────────────────────────────────────────────────
  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-logo">🏡</div>
        <span>Opening LittleNest...</span>
      </div>
    );
  }

  // ── Auth State ─────────────────────────────────────────────────────────────
  if (!currentUser) {
    return <AuthPage />;
  }

  // ── Role Routing ──────────────────────────────────────────────────────────
  // If user exists but is not in Firestore users collection yet (or doc deleted)
  if (!userProfile) {
    return (
      <div className="dashboard-wrapper">
        <div className="empty-state">
          <span>⚠️</span>
          <p>Profile not found. Please contact support or try logging in again.</p>
          <button className="btn-primary" onClick={() => window.location.reload()}>
            Reload Page
          </button>
        </div>
      </div>
    );
  }

  // Show dashboard based on role
  return userProfile.role === 'teacher' ? (
    <TeacherDashboard />
  ) : (
    <StudentDashboard />
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
